import { makeStyles } from '@material-ui/core/styles';

import { COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 545,
      width: 545,
    },
    dialogContent: {
      padding: theme.spacing(5, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    celebration: {
      position: 'relative',
    },
    channelIcon: {
      fontSize: theme.typography.pxToRem(48),
      position: 'absolute',
      bottom: 44.5,
      left: 53,
    },
    title: {
      margin: theme.spacing(3, 0, 1),
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(28),
      fontWeight: theme.typography.fontWeightSemiBold,
      fontFamily: FONTS.DMSans,
      textAlign: 'center',
    },
    accountDetails: {
      padding: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: COLORS.neutral.silver,
      color: COLORS.neutral.darkGray,
      width: 465,
      marginBottom: theme.spacing(3),
    },
  }),
  { name: 'AccountsDataExtractionPopup' }
);
